if (!window.location.pathname.includes('simulador-de-preguntas-basicas-tipo-pmp-capm-o-ipma')) {
  throw new Error('Not simulator page');
}

document.addEventListener('DOMContentLoaded', function () {

  var APPS_URL = 'https://script.google.com/macros/s/AKfycbzC6KsEp62gD1nW__VbujFI-Og7_Nmqvyi7ct9JcEEXJxCVMcptFsNEgw5UC9Vpor1d6w/exec';
  var usuario = { nombre: '', correo: '', serie: 'Examen muestra', origen: 'Blog Shopify' };

  // ── Inyectar CSS ──────────────────────────────────────────
  var css = `
    .sim-root { font-family: 'Poppins', sans-serif; padding: 20px; }
    .sim-container { background: #fff; border-radius: 10px; box-shadow: 0 4px 20px rgba(0,0,0,0.1); padding: 30px 20px; width: 100%; max-width: 800px; margin: 0 auto; }
    .sim-h1 { text-align: center; font-size: 20px; font-weight: 600; margin-bottom: 10px; color: #333; }
    .sim-subtitle { text-align: center; font-size: 14px; font-style: italic; margin-bottom: 20px; color: #333; }
    .sim-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; flex-wrap: wrap; }
    .sim-timer { font-size: 14px; font-style: italic; color: #FF8C00; }
    .sim-question { font-size: 14px; font-weight: 500; margin-bottom: 20px; color: #333; }
    .sim-btn-grid { display: grid; grid-template-columns: 1fr; gap: 10px; margin-bottom: 20px; }
    .sim-btn { background-color: #0046B5; border: 2px solid #FF8C00; color: #fff; padding: 10px 15px; text-align: left; font-size: 14px; font-weight: 500; cursor: pointer; border-radius: 8px; transition: all 0.3s ease; width: 100%; }
    .sim-btn:hover { background-color: #FF8C00; color: #fff; }
    .sim-btn.correct { background-color: #FF8C00; border-color: #FF8C00; color: #fff; }
    .sim-btn.wrong { background-color: #fff; border-color: #fff; color: #0046B5; }
    .sim-explanation { background-color: #F0F0F0; color: #333; border-left: 4px solid #FF8C00; padding: 10px; margin-top: 20px; border-radius: 0 8px 8px 0; white-space: pre-wrap; font-size: 14px; }
    .sim-controls { display: flex; justify-content: center; align-items: center; margin-top: 20px; flex-wrap: wrap; }
    .sim-start-btn, .sim-next-btn { background-color: #FF8C00; color: #fff; font-size: 14px; font-weight: 600; padding: 10px 20px; border: none; border-radius: 8px; cursor: pointer; transition: all 0.3s ease; margin: 5px; }
    .sim-start-btn:hover, .sim-next-btn:hover { background-color: #E67E00; }
    .sim-hide { display: none; }
    .sim-result { text-align: center; font-size: 14px; margin-top: 30px; }
    .sim-result-msg { font-size: 16px; font-weight: 600; margin-bottom: 20px; color: #FF8C00; }
    .sim-table-wrap { overflow-x: auto; margin-bottom: 20px; }
    .sim-table { width: 100%; min-width: 600px; border-collapse: collapse; margin-top: 20px; color: #333; font-size: 14px; }
    .sim-table th, .sim-table td { border: 1px solid #333; padding: 10px; text-align: left; }
    .sim-table th { background-color: #FF8C00; color: #fff; }
    .sim-table tr:nth-child(even) { background-color: rgba(0,0,0,0.05); }
    .sim-divider { border: none; border-top: 1px solid #E0E0E0; margin: 24px 0; }
    .sim-reg-titulo { font-size: 16px; font-weight: 600; color: #0046B5; margin-bottom: 6px; text-align: center; }
    .sim-reg-subtitulo { font-size: 13px; color: #666; text-align: center; margin-bottom: 24px; font-style: italic; }
    .sim-form-group { margin-bottom: 16px; }
    .sim-form-group label { display: block; font-size: 13px; font-weight: 600; color: #0046B5; margin-bottom: 6px; }
    .sim-form-group input[type="text"], .sim-form-group input[type="email"] { width: 100%; padding: 10px 14px; border: 1.5px solid #CCCCCC; border-radius: 8px; font-size: 14px; font-family: 'Poppins', sans-serif; color: #333; background-color: #fff; outline: none; box-sizing: border-box; }
    .sim-form-group input[type="text"]:focus, .sim-form-group input[type="email"]:focus { border-color: #0046B5; }
    .sim-input-error { border-color: #c0392b !important; }
    .sim-error-msg { font-size: 12px; color: #c0392b; margin-top: 4px; display: none; }
    .sim-disclaimer { background-color: #F0F4FF; border: 1px solid #C5D3F0; border-radius: 8px; padding: 14px 16px; margin-bottom: 20px; font-size: 12.5px; color: #444; line-height: 1.65; }
    .sim-disclaimer strong { display: block; font-size: 13px; color: #0046B5; margin-bottom: 6px; }
    .sim-check-wrap { display: flex; align-items: flex-start; gap: 10px; margin-top: 14px; cursor: pointer; }
    .sim-check-wrap input[type="checkbox"] { width: 17px; height: 17px; margin-top: 2px; flex-shrink: 0; cursor: pointer; }
    .sim-check-wrap span { font-size: 13px; color: #333; line-height: 1.5; }
    .sim-registrar-btn { width: 100%; background-color: #FF8C00; color: #fff; font-size: 15px; font-weight: 600; padding: 12px 20px; border: none; border-radius: 8px; cursor: pointer; transition: all 0.3s ease; font-family: 'Poppins', sans-serif; margin-top: 4px; }
    .sim-registrar-btn:hover { background-color: #E67E00; }
    .sim-registrar-btn:disabled { background-color: #CCCCCC; cursor: not-allowed; opacity: 0.7; }
    .sim-enviando { text-align: center; font-size: 13px; color: #0046B5; margin-top: 10px; display: none; font-style: italic; }
    .sim-result-cards { display: none; }
    @media (max-width: 600px) {
      .sim-container { padding: 20px 15px; }
      .sim-h1 { font-size: 18px; }
      .sim-header { flex-direction: column; align-items: flex-start; }
      .sim-btn { font-size: 12px; padding: 8px 12px; }
      .sim-table-wrap { display: none; }
      .sim-result-cards { display: flex; flex-direction: column; gap: 15px; margin-bottom: 20px; }
      .sim-result-card { background-color: #F0F0F0; border: 1px solid #FF8C00; border-radius: 8px; padding: 15px; }
      .sim-result-card h3 { font-size: 14px; color: #FF8C00; margin-bottom: 10px; }
      .sim-result-card p { font-size: 12px; margin-bottom: 5px; }
    }
  `;
  var styleTag = document.createElement('style');
  styleTag.textContent = css;
  document.head.appendChild(styleTag);

  // ── Inyectar HTML ─────────────────────────────────────────
  var html = `
    <div class="sim-container">
      <h1 class="sim-h1">Examen muestra para certificacion en Administracion de Proyectos</h1>
      <div class="sim-subtitle">Prueba en que nivel estas</div>

      <div id="sim-registro">
        <hr class="sim-divider">
        <p class="sim-reg-titulo">Antes de comenzar, registrate</p>
        <p class="sim-reg-subtitulo">Solo necesitamos tu nombre y correo para enviarte tus resultados y recomendaciones de estudio.</p>
        <div class="sim-form-group">
          <label for="sim-nombre">Nombre completo *</label>
          <input type="text" id="sim-nombre" placeholder="Ej. Juan Perez Garcia" autocomplete="name">
          <div class="sim-error-msg" id="sim-err-nombre">Por favor ingresa tu nombre completo.</div>
        </div>
        <div class="sim-form-group">
          <label for="sim-correo">Correo electronico *</label>
          <input type="email" id="sim-correo" placeholder="Ej. juan@empresa.com" autocomplete="email">
          <div class="sim-error-msg" id="sim-err-correo">Por favor ingresa un correo electronico valido.</div>
        </div>
        <div class="sim-disclaimer">
          <strong>Aviso de privacidad y uso de datos</strong>
          Los datos que proporcionas (nombre y correo electronico) seran utilizados exclusivamente con fines educativos: respaldar tus resultados del examen y enviarte recomendaciones personalizadas de preparacion para la certificacion PMP. Coordinate.mx no compartira tu informacion con terceros ni la utilizara para fines comerciales sin tu consentimiento previo. Puedes solicitar la eliminacion de tus datos en cualquier momento escribiendo a adanlopez@coordinate.mx.
          Los resultados del examen y recomendaciones quedan a consideracion del aplicante, no constituyen una obligacion de ningun tipo para Coordinate.mx.
          <label class="sim-check-wrap">
            <input type="checkbox" id="sim-check">
            <span>He leido y acepto el aviso de privacidad y el uso de mis datos con fines educativos.</span>
          </label>
        </div>
        <button class="sim-registrar-btn" id="sim-registrar-btn" disabled>Continuar al examen &rarr;</button>
        <div class="sim-enviando" id="sim-enviando">Registrando tu informacion, un momento...</div>
      </div>

      <div id="sim-simulador" class="sim-hide">
        <div class="sim-header">
          <div></div>
          <div id="sim-timer" class="sim-timer">Tiempo disponible: 10:00</div>
        </div>
        <div id="sim-question-container" class="sim-hide">
          <div id="sim-question" class="sim-question"></div>
          <div id="sim-answers" class="sim-btn-grid"></div>
          <div id="sim-explanation" class="sim-explanation sim-hide"></div>
        </div>
        <div class="sim-controls">
          <button id="sim-start-btn" class="sim-start-btn">Iniciar Examen</button>
          <button id="sim-next-btn" class="sim-next-btn sim-hide">Siguiente</button>
        </div>
        <div id="sim-result" class="sim-result sim-hide">
          <h2>Resultados del Examen</h2>
          <p class="sim-result-msg">Tu resultado es: <span id="sim-score"></span> de 10</p>
          <div class="sim-table-wrap">
            <table class="sim-table"><tbody>
              <tr><th>Respuestas correctas</th><th>Para examen CAPM</th><th>Para examen PMP</th></tr>
              <tr><td>Una a tres</td><td>Asigna 20 horas para un curso y un simulador</td><td>Asigna 60 horas para un curso basico, un curso de preparacion y un simulador</td></tr>
              <tr><td>Cuatro a siete</td><td>Asigna 20 horas de un simulador</td><td>Asigna aproximadamente 40 horas de curso y un simulador</td></tr>
              <tr><td>Ocho a diez</td><td>Estas listo, presenta el examen</td><td>Asignando aproximadamente 20 horas con un simulador</td></tr>
            </tbody></table>
          </div>
          <div class="sim-result-cards">
            <div class="sim-result-card"><h3>Una a tres respuestas correctas</h3><p><strong>CAPM:</strong> Asigna 20 horas para un curso y un simulador.</p><p><strong>PMP:</strong> Asigna 60 horas para un curso basico, preparacion y un simulador.</p></div>
            <div class="sim-result-card"><h3>Cuatro a siete respuestas correctas</h3><p><strong>CAPM:</strong> Asigna 20 horas de un simulador.</p><p><strong>PMP:</strong> Asigna aproximadamente 40 horas de curso y un simulador.</p></div>
            <div class="sim-result-card"><h3>Ocho a diez respuestas correctas</h3><p><strong>CAPM:</strong> Estas listo, presenta el examen.</p><p><strong>PMP:</strong> Aproximadamente 20 horas con un simulador.</p></div>
          </div>
          <p><em>*Las recomendaciones estan basadas en que el aplicante tiene experiencia de dos o mas anos trabajando en proyectos. La muestra de diez preguntas es pequena, la confiabilidad es contingente.</em></p>
        </div>
      </div>
    </div>
  `;

  var target = document.querySelector('.article-template__content') || document.body;
  target.innerHTML = html;

  // ── Variables del DOM ─────────────────────────────────────
  var elNombre  = document.getElementById('sim-nombre');
  var elCorreo  = document.getElementById('sim-correo');
  var elCheck   = document.getElementById('sim-check');
  var elBtn     = document.getElementById('sim-registrar-btn');
  var elTimer   = document.getElementById('sim-timer');
  var elStart   = document.getElementById('sim-start-btn');
  var elNext    = document.getElementById('sim-next-btn');
  var elQWrap   = document.getElementById('sim-question-container');
  var elQ       = document.getElementById('sim-question');
  var elAnswers = document.getElementById('sim-answers');
  var elExp     = document.getElementById('sim-explanation');
  var elResult  = document.getElementById('sim-result');
  var elScore   = document.getElementById('sim-score');

  var indice, puntaje, tiempoRestante, intervalo;

  // ── Validacion del formulario ─────────────────────────────
  function validar() {
    var nombre = elNombre.value.trim();
    var correo = elCorreo.value.trim();
    var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo);
    elBtn.disabled = !(nombre.length >= 2 && ok && elCheck.checked);
  }

  elNombre.addEventListener('input', validar);
  elCorreo.addEventListener('input', validar);
  elCheck.addEventListener('change', validar);

  elNombre.addEventListener('blur', function () {
    var err = document.getElementById('sim-err-nombre');
    if (elNombre.value.trim().length < 2) { elNombre.classList.add('sim-input-error'); err.style.display = 'block'; }
    else { elNombre.classList.remove('sim-input-error'); err.style.display = 'none'; }
  });

  elCorreo.addEventListener('blur', function () {
    var err = document.getElementById('sim-err-correo');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(elCorreo.value.trim())) { elCorreo.classList.add('sim-input-error'); err.style.display = 'block'; }
    else { elCorreo.classList.remove('sim-input-error'); err.style.display = 'none'; }
  });

  // ── Registro inicial ──────────────────────────────────────
  elBtn.addEventListener('click', function () {
    usuario.nombre = elNombre.value.trim();
    usuario.correo = elCorreo.value.trim();
    elBtn.disabled = true;
    document.getElementById('sim-enviando').style.display = 'block';
    var p = new URLSearchParams({ nombre: usuario.nombre, correo: usuario.correo, serie: usuario.serie, origen: usuario.origen });
    fetch(APPS_URL + '?' + p.toString(), { method: 'GET' }).catch(function (e) { console.warn('Registro inicial:', e.message); });
    document.getElementById('sim-registro').classList.add('sim-hide');
    document.getElementById('sim-simulador').classList.remove('sim-hide');
  });

  // ── Envio de resultado ────────────────────────────────────
  function enviarResultado() {
    if (!usuario.correo) return;
    var p = new URLSearchParams({ nombre: usuario.nombre, correo: usuario.correo, serie: usuario.serie, score: Math.round((puntaje / preguntas.length) * 100), correctas: puntaje, incorrectas: preguntas.length - puntaje, omitidas: 0, tiempo_seg: 600 - tiempoRestante, total_preguntas: preguntas.length, origen: usuario.origen });
    fetch(APPS_URL + '?' + p.toString(), { method: 'GET' }).catch(function (e) { console.warn('Resultado:', e.message); });
  }

  // ── Banco de preguntas ────────────────────────────────────
  var preguntas = [
    { q: '1. Un director de proyecto esta gestionando un proyecto retrasado por demoras en la recepcion de equipos criticos. Que debe hacer primero?', ops: ['A) Acelerar el cronograma anadiendo mas recursos', 'B) Acelerar superponiendo actividades', 'C) Actualizar el registro de riesgos', 'D) Realizar un analisis de causa raiz'], c: 3, exp: 'D) es correcta. Antes de tomar medidas es esencial identificar la causa raiz. A y B pueden no ser la solucion sin conocer la causa. C no es correcta porque el retraso ya ocurrio, no es un riesgo futuro.' },
    { q: '2. El equipo identifico un riesgo potencial que podria afectar un componente clave. Cual es la mejor manera de gestionarlo?', ops: ['A) Aceptar el riesgo y continuar', 'B) Mitigar el riesgo reduciendo su impacto', 'C) Transferir el riesgo a un tercero', 'D) Evitar el riesgo eliminando el componente'], c: 1, exp: 'B) es correcta. Mitigar implica acciones proactivas para reducir probabilidad o impacto. Transferir C) implica tiempo adicional. Aceptar A) solo aplica para fuerza mayor. Eliminar D) requiere cambio de alcance.' },
    { q: '3. El patrocinador pide entregar el proyecto un mes antes sin cambios en alcance ni recursos. Que hace el director?', ops: ['A) Aplicar compresion de cronograma como superposicion de actividades', 'B) Aceptar y reducir el alcance', 'C) Rechazar porque el cronograma no puede cambiar sin mas recursos', 'D) Agregar mas personal al equipo'], c: 0, exp: 'A) es correcta. El fast-tracking permite reducir tiempo sin cambiar alcance ni recursos. B y D modifican alcance o recursos. C es prematura sin analizar opciones de compresion primero.' },
    { q: '4. Durante la ejecucion, un miembro clave del equipo se retira. Que deberia hacer primero el director?', ops: ['A) Actualizar el cronograma', 'B) Informar al patrocinador', 'C) Contratar un nuevo miembro inmediatamente', 'D) Evaluar el impacto de la salida en el proyecto'], c: 3, exp: 'D) es correcta. Antes de actualizar el cronograma, informar al patrocinador o contratar a alguien, es esencial evaluar el impacto real de la salida para tomar decisiones informadas.' },
    { q: '5. El equipo identifica que un entregable clave no cumplira los requisitos de calidad. Que hace primero el director?', ops: ['A) Informar a los interesados', 'B) Revisar el plan de gestion de calidad y el plan de control de calidad', 'C) Solicitar mas tiempo', 'D) Aceptar el entregable para evitar retrasos'], c: 1, exp: 'B) es correcta. El plan de gestion de calidad contiene las directrices para gestionar este problema. Informar A) o solicitar tiempo C) son acciones posteriores. Aceptar D) es el ultimo recurso.' },
    { q: '6. Al cerrar el proyecto el cliente encuentra defectos. Que hace el director a continuacion?', ops: ['A) Revisar el resultado contra los criterios de aceptacion', 'B) Extender el proyecto hasta que se acepten todos los entregables', 'C) Persuadir al cliente para que acepte el resultado', 'D) Pagar la penalizacion por el elemento defectuoso'], c: 0, exp: 'A) es correcta. Lo primero es revisar contra los criterios de aceptacion definidos. Extender B) no es adecuado. Convencer C) va contra las mejores practicas. Las penalizaciones D) se consideran despues de agotar otras opciones.' },
    { q: '7. El rendimiento se evalua continuamente para determinar beneficios. Que accion debe tomar el director al inicio?', ops: ['A) Asegurar aprobacion de parametros de rendimiento con interesados', 'B) Mantener reuniones periodicas con todos los interesados', 'C) Acordar los requisitos para el seguimiento de las mediciones', 'D) Revisar la administracion del proyecto regularmente'], c: 2, exp: 'C) es correcta. Acordar los requisitos para el seguimiento garantiza que las metricas sean claras y aceptadas desde el inicio, facilitando la evaluacion continua del desempeno.' },
    { q: '8. Que representa la ruta critica en la gestion de proyectos?', ops: ['A) La secuencia con mayor cantidad de recursos asignados', 'B) La ruta con las actividades mas costosas', 'C) La secuencia que determina la duracion mas corta posible', 'D) La secuencia sin holgura que define la duracion total del proyecto'], c: 3, exp: 'D) es correcta. La ruta critica es la secuencia mas larga de actividades sin holgura (float). Cualquier demora en ellas afecta directamente la fecha final del proyecto.' },
    { q: '9. PV=50,000 USD, EV=45,000 USD, AC=55,000 USD. Cuales son el CPI y SPI?', ops: ['A) CPI=0.82 y SPI=0.90 - sobre presupuesto y retrasado', 'B) CPI=1.22 y SPI=0.90 - bajo presupuesto y retrasado', 'C) CPI=0.82 y SPI=1.11 - sobre presupuesto y adelantado', 'D) CPI=1.11 y SPI=1.22 - bajo presupuesto y adelantado'], c: 0, exp: 'A) es correcta. CPI=EV/AC=45,000/55,000=0.82 (sobre presupuesto). SPI=EV/PV=45,000/50,000=0.90 (retrasado). Un CPI o SPI menor a 1.0 indica desempeno negativo.' },
    { q: '10. Un equipo agil tiene dificultades para mantener comunicacion efectiva durante los sprints. Que practica seria mas efectiva?', ops: ['A) Crear un cronograma detallado con hitos desde el inicio', 'B) Implementar reuniones diarias de pie (daily stand-ups)', 'C) Establecer un comite de control de cambios', 'D) Introducir informes de desempeno semanal al patrocinador'], c: 1, exp: 'B) es correcta. Las reuniones diarias de pie son fundamentales en metodologias agiles para sincronizar al equipo, identificar obstaculos y mejorar la comunicacion rapidamente.' }
  ];

  // ── Logica del simulador ──────────────────────────────────
  elStart.addEventListener('click', function () {
    elStart.classList.add('sim-hide');
    indice = 0; puntaje = 0;
    elQWrap.classList.remove('sim-hide');
    tiempoRestante = 600;
    actualizarTimer();
    intervalo = setInterval(function () {
      tiempoRestante--;
      actualizarTimer();
      if (tiempoRestante <= 0) { clearInterval(intervalo); terminar(); }
    }, 1000);
    mostrarPregunta();
  });

  elNext.addEventListener('click', function () { indice++; mostrarPregunta(); });

  function actualizarTimer() {
    var m = Math.floor(tiempoRestante / 60);
    var s = tiempoRestante % 60;
    elTimer.textContent = 'Tiempo disponible: ' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function mostrarPregunta() {
    elNext.classList.add('sim-hide');
    elExp.classList.add('sim-hide');
    elExp.textContent = '';
    elAnswers.innerHTML = '';
    var p = preguntas[indice];
    elQ.textContent = p.q;
    p.ops.forEach(function (op, i) {
      var b = document.createElement('button');
      b.className = 'sim-btn';
      b.textContent = op;
      b.addEventListener('click', function () { responder(i, p); });
      elAnswers.appendChild(b);
    });
  }

  function responder(i, p) {
    var btns = elAnswers.querySelectorAll('.sim-btn');
    btns.forEach(function (b, idx) {
      b.disabled = true;
      if (idx === p.c) b.classList.add('correct');
      else if (idx === i) b.classList.add('wrong');
    });
    if (i === p.c) puntaje++;
    elExp.textContent = p.exp;
    elExp.classList.remove('sim-hide');
    if (indice < preguntas.length - 1) {
      elNext.classList.remove('sim-hide');
    } else {
      clearInterval(intervalo);
      terminar();
    }
  }

  function terminar() {
    elQWrap.classList.add('sim-hide');
    elNext.classList.add('sim-hide');
    elResult.classList.remove('sim-hide');
    elScore.textContent = puntaje;
    elStart.textContent = 'Reiniciar';
    elStart.classList.remove('sim-hide');
    enviarResultado();
  }

});